'use client';

import { useEffect, useState } from 'react';

import { MAIN_STORY_ID } from '../story-section';

// 스토리 섹션이 화면에 한 번이라도 들어왔는지.
// 뒤쪽 섹션(전환·하이라이트)의 배경 영상을 미리 받는 기준점이다. 각 섹션이
// 자기 자리에서 기다리면 도착했을 때 아직 비어 있고, 그렇다고 거리(margin)로
// 당기면 스토리가 첫 화면 바로 아래라 스크롤을 안 해도 발동한다. 히어로만 보고
// 떠나는 사람에게 수 MB 를 지우지 않으려면 기준을 스토리 진입으로 둬야 한다.
export function useStoryReached() {
  const [reached, setReached] = useState(false);

  useEffect(() => {
    const story = document.getElementById(MAIN_STORY_ID);
    if (!story) return;
    const observer = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting)) return;
      setReached(true);
      observer.disconnect();
    });
    observer.observe(story);
    return () => observer.disconnect();
  }, []);

  return reached;
}
